import React from 'react';
import { useContent } from '../contexts/ContentContext';
import { useIllustrationIndex } from '../hooks/useIllustrationIndex';
import { removeSearchCondition, searchConditions, searchFilters } from '../utils/publicSearch';
import { FilterCondition } from './AppliedFilters';

export default function SearchConditionChips({ params, onChange }: { params: URLSearchParams; onChange: (params: URLSearchParams) => void }) {
    const { content, language, t } = useContent();
    const { data } = useIllustrationIndex();
    return <>{searchConditions(params).map(({ key, value }) => {
        const group = key === 'tags' ? t('header.word') : key === 'color' ? t('common.color') : content.ui[language].search.group[key as keyof typeof content.ui.jp.search.group] || key;
        const name = key === 'rating' ? `★${value}` : data?.groups[key]?.values.find(item => item.slug === value)?.label || value;
        const label = key === 'year' ? params.has('month') ? t('search.month', { year: value, month: params.get('month')! }) : `${t('illustrations.year')}: ${value}` : `${group}: ${name}`;
        const choices = key === 'rating' ? (data?.ratings || []).map(item => ({ value: String(item.value), label: `★${item.value}`, count: item.count }))
            : (data?.groups[key]?.values || []).map(item => ({ value: item.slug, label: item.label, count: item.count }));
        return <FilterCondition key={key + ':' + value} label={label} value={value} choices={choices}
            onSelect={selected => { const next = searchFilters(params); next.set(key, selected); onChange(next); }}
            onRemove={() => onChange(removeSearchCondition(params, key, value))} />;
    })}</>;
}
